import React from "react";
import { Header, H1 } from "./style";

const Title2 = ({ title }) => {
  return (
    <Header>
      <H1>{title}</H1>
      {/* <Icons>
        <Icon name='arrow left' />
        <Icon name='arrow right' />
      </Icons> */}
    </Header>
  );
};

export default Title2;
